import React from 'react';
import { I18n as I } from 'react-redux-i18n';
import LookupsHelper from 'lib/LookupsHelper';

import { TooltipButton, TooltipLink } from 'vdlib';
import { Typography } from 'antd';

const { Paragraph } = Typography;

const getColumns = (regions, partyTypes, setPartyToToggle) => [
  {
    title: I.t('SN'),
    key: 'ID',
    dataIndex: 'ID',
    width: 100,
    align: 'center',
  },
  {
    title: I.t('PARTY_TYPE'),
    key: 'PartyType',
    dataIndex: 'PartyType',
    width: 100,
    align: 'center',
    render: (text, record) =>
      LookupsHelper.getDescription(partyTypes, record.PartyTypeID),
  },
  {
    title: I.t('FIRSTNAME'),
    key: 'FirstName',
    dataIndex: 'FirstName',
    width: 200,
    align: 'center',
  },
  {
    title: I.t('TITLE'),
    key: 'SurName',
    dataIndex: 'SurName',
    width: 250,
    align: 'center',
  },
  {
    title: I.t('DISTINCTIVE_TITLE'),
    key: 'DistinctiveTitle',
    dataIndex: 'DistinctiveTitle',
    align: 'center',
  },
  {
    title: I.t('EMAIL'),
    key: 'Email',
    dataIndex: 'Email',
    width: 300,
    align: 'center',
    render: (text, record) => <Paragraph copyable>{text}</Paragraph>,
  },
  {
    title: I.t('REGION'),
    key: 'RegionID',
    dataIndex: 'RegionID',
    width: 100,
    align: 'center',
    render: (text, record) =>
      LookupsHelper.getDescription(regions, record.RegionID),
  },
  {
    title: I.t('PHONE'),
    key: 'Phone',
    dataIndex: 'Phone',
    width: 100,
    align: 'center',
  },
  {
    title: I.t('PARTY_STATUS'),
    key: 'IsInactive',
    dataIndex: 'IsInactive',
    width: 100,
    align: 'center',
    render: (text, record) =>
      record.IsInactive ? I.t('DEACTIVATED') : I.t('ACTIVE'),
  },
  {
    title: '',
    key: 'Action',
    width: 80,
    align: 'center',
    fixed: 'right',
    render: (text, record) => (
      <div className="cell-fix-wrap">
        <TooltipButton
          onClick={() => setPartyToToggle(record)}
          className={
            record.IsInactive ? 'green action-button' : 'red action-button'
          }
          icon={record.IsInactive ? 'unlock' : 'lock'}
          text={record.IsInactive ? I.t('ACTIVATION') : I.t('DEACTIVATION')}
        />
        <TooltipLink
          style={{ marginLeft: 5 }}
          to={'/parties/' + record.ID}
          className="blue action-button"
          icon="info-circle"
          text={I.t('MORE')}
        />
      </div>
    ),
  },
];
export { getColumns };
